//Breakpoints
$medium = 768;
$large = 992;

//All pages
(function ($) {
  var windowObj = $(window); //window cached in var for performance
  var pellingBody = $("body"); //body cached in var for performance
  var documentObj = $(document);
  /***
  ********
  ****
  Smooth Scrolling Function (redunant due to hashHandler()?)
  ****
  ********
  ***/
  function smoothScrolling() {
    $(
      'a[href*=\\#]:not([href=\\#],[href="\\#0"],[data-toggle="tab"],.no-smooth-scroll)'
    ).click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");

        let offset = window.innerWidth < 992 ? 30 : 50;
        offset += document.querySelector(".site-header").offsetHeight;
        offset += document.body.classList.contains("admin-bar")
          ? document.getElementById("wpadminbar").offsetHeight
          : 0;

        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
          return false;
        }
      }
    });
  }
  smoothScrolling();
  /***
  ********
  ****
  Return to top anchor
  ****
  ********
  ***/
  function returnTop() {
    var returnTop = $(".return-to-top");
    windowObj.scroll(function () {
      if ($(this).scrollTop() >= 50) {
        returnTop.fadeIn(200);
      } else {
        returnTop.fadeOut(200);
      }
    });
    returnTop.on("click", function () {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        500
      );
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  pelling Navbar Functionality
  ****
  ********
  ***/
  function pellingNavbar() {
    var site_header = $(".site-header");
    var nav_toggle = $(".site-header__navbar-toggler");
    //shrink navbar on scroll
    windowObj.scroll(function () {
      if (documentObj.scrollTop() > 50) {
        if (site_header.hasClass("site-header--transparent")) {
          site_header.removeClass("site-header--transparent");
          site_header.addClass(
            "site-header--shrink site-header--return-to-transparent"
          );
        } else if (site_header.hasClass("site-header--white-bg")) {
          site_header.addClass("site-header--shrink");
        }
      } else {
        if (site_header.hasClass("site-header--return-to-transparent")) {
          site_header.removeClass(
            "site-header--return-to-transparent site-header--shrink"
          );
          site_header.addClass("site-header--transparent");
        }
      }
    });
    var slide_out_navbar = $(".slideout-navbar");
    var sub_menu = $(".sub-menu");
    $(".navbar-dropdown-anchor-parent").on("click", function (e) {
      e.preventDefault();
      slide_out_navbar.addClass("slideout-navbar--visible");
      sub_menu.removeClass("sub-menu-visible");
      $(this).next(".sub-menu").addClass("sub-menu-visible");
    });
    $(".slideout-navbar__close").on("click", function () {
      sub_menu.removeClass("sub-menu-visible");
      slide_out_navbar.removeClass("slideout-navbar--visible");
    });
    $(".close-sub-menu-btn").on("click", function () {
      sub_menu.removeClass("sub-menu-visible");
      slide_out_navbar.removeClass("slideout-navbar--visible");
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  GDPR Consent Bar Functionality
  ****
  ********
  ***/
  function gdprConsent() {
    var gdprConsentBar = $(".gdpr-consent");
    windowObj.scroll(function () {
      if (documentObj.scrollTop() > 70) {
        gdprConsentBar.addClass("gdpr-hidden animated");
      } else {
        gdprConsentBar.removeClass("gdpr-hidden animated");
      }
    });

    $(".gdpr-give-consent").click(function (event) {
      event.preventDefault();
      Cookies.remove("pelling_gdpr_consent_undecided");
      Cookies.set("pelling_gdpr_consent", 1, { expires: 365, path: "/" });
      gdprConsentBar.hide();
      //$('.gdpr-consent__accepted-notice').addClass('show-accepted-message animated');
    });

    $(".gdpr-close").click(function (event) {
      gdprConsentBar.addClass("gdpr-hidden animated");
      setTimeout(function () {
        gdprConsentBar.remove();
      }, 2000);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  pelling Accordion Functionality
  ****
  ********
  ***/
  function pellingAccordions() {
    $(".accordion__title").each(function () {
      var accordion = $(this),
        state = false,
        accordionContent = accordion
          .next(".accordion__content")
          .hide()
          .css("height", "auto")
          .slideUp();
      accordion.click(function () {
        state = !state;
        accordionContent.slideToggle(state);
        accordion.parent().toggleClass("accordion-open", state);
      });
    });
  }
  pellingAccordions();
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  pelling horizontal tabs flickity init
  ****
  ********
  ***/
  function horizontalTabsInit() {
    $(".pelling-horizontal-tabs__content").each(function () {
      // init Flickity
      var $carousel = $(this).flickity({
        prevNextButtons: false,
        pageDots: false,
        autoPlay: $(this).data("autoplay"),
      });
      // Flickity instance
      var flkty = $carousel.data("flickity");
      // elements
      var $cellButtonGroup = $(".pelling-horizontal-tabs__nav");
      var $cellButtons = $cellButtonGroup.find(
        ".pelling-horizontal-tabs__nav__item"
      );

      // update selected cellButtons
      $carousel.on("select.flickity", function () {
        $cellButtons.filter(".is-selected").removeClass("is-selected");
        $cellButtons.eq(flkty.selectedIndex).addClass("is-selected");
      });

      // select cell on button click
      $cellButtonGroup.on(
        "click",
        ".pelling-horizontal-tabs__nav__item",
        function () {
          var index = $(this).index();
          $carousel.flickity("select", index);
        }
      );
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  pelling testimonial carousel
  ****
  ********
  ***/
  function testimonialCarouselInit() {
    $(".pelling-testimonial-carousel__content__testimonials").each(function () {
      // init Flickity
      var $carousel = $(this).flickity({
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: $(this).data("autoplay"),
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  pelling carousel
  ****
  ********
  ***/
  function carouselInit() {
    $(".pelling-carousel__items").each(function () {
      // init Flickity
      var $carousel = $(this).flickity({
        pageDots: false,
        contain: true,
        resize: true,
        autoPlay: $(this).data("autoplay"),
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  pelling resources carousel
  ****
  ********
  ***/
  function resourcesCarouselInit() {
    $(".resources-carousel__carousel").each(function () {
      // init Flickity
      var $carousel = $(this).flickity({
        pageDots: false,
        wrapAround: true,
        resize: true,
        autoPlay: $(this).data("autoplay"),
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Sections
  ****
  ********
  ***/
  function animateSections() {
    /*$('.watch-in-view').each(function() {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          $(this.element).addClass('in-view');
        },
        offset: -50
      });
    });*/
    $(".watch-in-view").each(function () {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function (direction) {
          $(this.element).addClass("in-view animate__animated");
          //console.log('Enter triggered with direction ' + direction + ' ' + this.element);
        },
        offset: {
          //top: 200, // 300px
          bottom: 200, // 200px
        },
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Sections
  ****
  ********
  ***/
  function animatedStatistics() {
    $(
      ".statistic-columns__item__statistic__value,.statistic-bar__item__statistic__value"
    ).each(function () {
      var $this = $(this);
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function (direction) {
          var start = $(this.element).data("start");
          var target = $(this.element).data("target");
          $({ Counter: start }).animate(
            { Counter: target },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                $this.text(Math.ceil(now));
              },
            }
          );
          this.destroy();
        },
        offset: {
          //top: 200, // 300px
          bottom: 200, // 200px
        },
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function clientCarousel() {
    var carousel = $(".client-carousel__carousel");
    if (carousel != null) {
      var $carousel = $(".client-carousel__carousel").flickity({
        // options
        cellAlign: "center",
        pageDots: true,
        wrapAround: true,
        adaptiveHeight: true,
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function heroCarousel() {
    var carousel = $(".thumbnail-nav__carousel");
    if (carousel != null) {
      var $carousel = $(".thumbnail-nav__carousel").flickity({
        // options
        cellAlign: "center",
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        watchCSS: true,
        autoPlay: true
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function portfolioCarousel() {
    var carousel = $(".portfolio__carousel");
    if (carousel != null) {
      if (windowObj.width() > 1200) {
        var cellSelector = ".portfolio__group";
      } else {
        var cellSelector = ".portfolio__item";
      }
      var $carousel = $(".portfolio__carousel").flickity({
        // options
        cellAlign: "center",
        pageDots: false,
        wrapAround: true,
        resize: true,
        cellSelector: cellSelector,
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Bootstrap Tabs
  ****
  ********
  ***/
  function bsTabs() {
    if (windowObj.width() < 1200) {
      $(".nav-link").on("show.bs.tab", function (e) {
        $("html, body").animate(
          {
            //TODO add sibling / next rather than explicit
            scrollTop: $("#tab-content-anchor").offset().top,
          },
          500
        );
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Bootstrap Tabs
  ****
  ********
  ***/
  function isotopeGallery() {
    var $grid = $(".gallery__gallery").isotope({
      // main isotope options
      itemSelector: ".gallery__item",
      // set layoutMode
      layoutMode: "packery",
      // options for masonry layout mode
      packery: {
        gutter: ".gallery__gutter-sizer",
      },
    });
    //wait till images have loaded so they have correct size, then render layout
    $grid.imagesLoaded().progress(function () {
      $grid.isotope("layout");
    });
  }
  /******* Executed in document ready at end of file *******/
  //mediabox video modals
  MediaBox(".mediabox");
  //match height of grouped elements
  $(".matchHeight").matchHeight();

  /*Overlapping CTA Image dynamic CSS*/
  // function dynamicBannerHeight() {
  //   let banner = document.querySelector(".overlapping-cta-image__banner");
  //   let overlappingCtaImage = document.querySelector(".overlapping-cta-image");
  //   let box = document.querySelector(".overlapping-cta-image__box");

  //   if (banner) {
  //     overlappingCtaImage.style.marginTop = `calc(${banner.offsetHeight}px/3)`;
  //     overlappingCtaImage.style.minHeight = `calc(${box.offsetHeight}px * 3)`;
  //     box.style.top = `calc(50% + ${banner.offsetHeight}px/3)`;
  //   }
  // }

  /*Inset Banner dynamic CSS*/
  // function insetBannerCSS() {
  //   let insetBanners = document.querySelectorAll(".inset-banner")

  //   insetBanners.forEach(banner => {

  //     let insetBannerContainer = banner.querySelector(
  //       ".inset-banner__container"
  //     );
  //     let insetBannerImage = banner.querySelector(".inset-banner__image");

  //     if (insetBannerImage) {
  //       if (window.innerWidth >= 768) {
  //         banner.querySelector(
  //           ".inset-banner__content"
  //         ).style.marginRight = `${insetBannerImage.offsetWidth}px`;
  //       } else {
  //         banner.querySelector(".inset-banner__content").style.marginRight =
  //           "0";
  //       }

  //       banner.style.marginTop = `${Math.max(
  //         0,
  //         insetBannerImage.offsetHeight - insetBannerContainer.offsetHeight
  //       )}px`;
  //     }

  //   })
  // }

  /*Banner dynamic CSS*/
  function bannerDynamicCSS(target) {
    let elements = document.querySelectorAll(target);

    elements.forEach((el) => {
      let container = el.querySelector(`${target}__container`);
      let image = el.querySelector(`${target}__image`);

      if (!image.complete) {
        image.addEventListener("load", () => setStyles());
      } else {
        setStyles();
      }

      function setStyles() {
        if (image) {
          if (
            (target == ".inset-banner" && window.innerWidth >= $medium) ||
            window.innerWidth >= $large
          ) {
            if (target == ".cta-banner" && window.innerWidth >= $large) {
              el.querySelector(`${target}__content`).style.marginRight = `${
                image.offsetWidth - 100
              }px`;
            } else {
              el.querySelector(`${target}__content`).style.marginRight = `${
                image.offsetWidth + 50
              }px`;
            }
          } else {
            el.querySelector(`${target}__content`).style.marginRight = "0";
          }

          //Add dynamic overlap if enabled, or add padding-top to current block otherwise
          if (
            el.classList.contains(`${target}--overlap-previous`.substring(1))
          ) {
            let previousBlock = el.previousElementSibling;

            if (previousBlock) {
              previousBlock.style.removeProperty("padding-bottom");
            }

            if (image.offsetHeight - container.offsetHeight > 0) {
              if (previousBlock) {
                previousBlock.style.paddingBottom = `${Math.max(
                  0,
                  image.offsetHeight -
                    container.offsetHeight +
                    Math.min(50, image.offsetHeight - container.offsetHeight)
                )}px`;
              }
            }
          } else {
            el.style.paddingTop = `${Math.max(
              0,
              image.offsetHeight - container.offsetHeight
            )}px`;
          }
        }
      }

      setStyles();
    });
  }

  /*Overlap Next*/
  function overlapNext(el) {
    const next = el.nextElementSibling;
    next.style.removeProperty("padding-top");

    if (next.tagName == "SECTION") {
      const nextPadding =
        getComputedStyle(next).getPropertyValue("padding-top");
      const elHeight = getComputedStyle(el).getPropertyValue("height");

      el.style.marginBottom = `calc(-${elHeight} + 100px)`;
      next.style.paddingTop = `calc(${nextPadding} + ${elHeight} - 100px)`;
    }
  }

  /*Hero Carousel*/
  function heroCarouselInit() {
    $(".hero-carousel__items").each(function () {
      // init Flickity
      let $carousel = $(this).flickity({
        pageDots: false,
        contain: true,
        resize: false,
        autoPlay: true,//$(this).data("autoplay"),
        wrapAround: true,
        freeScroll: false,
        draggable: true,
        adaptiveHeight: true,
        prevNextButtons: true,
      });

      function updateDots(thisObj) {
        let index = thisObj.index();
        let flkty = $carousel.data("flickity");

        thisObj.removeClass("hero-carousel__indicator--is-selected");

        if (index == flkty.selectedIndex) {
          thisObj.addClass("hero-carousel__indicator--is-selected");
        }
      }

      //Set initial selected dot
      $(".hero-carousel__indicator").each(function () {
        updateDots($(this));
      });

      //Handle dot clicks
      $(".hero-carousel__indicator").on("click", function () {
        let index = $(this).index();
        $carousel.flickity("select", index);

        $(".hero-carousel__indicator").each(function () {
          updateDots($(this));
        });
      });

      //Update dots on drag
      $carousel.on("select.flickity", function () {
        $(".hero-carousel__indicator").each(function () {
          updateDots($(this));
        });
      });

      //Handle resize
      // window.addEventListener('resize', function(){
      //   $carousel.flickity('resize');
      // })
    });
  }

  /*Clients Carousel*/
  function clientsCarousel() {
    document.querySelectorAll(".client-logos").forEach((block) => {
      // init Flickity
      let carousel = new Flickity(block.querySelector(".client-logos__items"), {
        pageDots: false,
        contain: true,
        resize: false,
        autoPlay: $(this).data("autoplay") ? "3000" : false,
        wrapAround: true,
        freeScroll: false,
        draggable: true,
        adaptiveHeight: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        cellAlign: "center",
        imagesLoaded: true,
      });

      //Handle resize
      window.addEventListener(
        "resize",
        debounce(function () {
          carousel.flickity("resize");
        })
      );

      //Smooth scroll
      let requestId;
      carousel.x = 0;

      play();

      function play() {
        // Set the decrement of position x
        carousel.x = carousel.x - 0.25;
        // Settle position into the slider
        carousel.settle(carousel.x);
        // Set the requestId to the local variable
        requestId = window.requestAnimationFrame(play);
      }

      function pause() {
        if (requestId) {
          // Cancel the animation
          window.cancelAnimationFrame(requestId);
          // Reset the requestId for the next animation.
          requestId = undefined;
        }
      }

      // Pause on hover/focus
      block
        .querySelector(".client-logos__items")
        .addEventListener("mouseenter", () => {
          pause();
        });

      // // Unpause on mouse out / defocus
      block
        .querySelector(".client-logos__items")
        .addEventListener("mouseleave", () => {
          play();
        });
    });
  }

  /*CTA Banner*/
  function ctaBanner() {
    const banners = document.querySelectorAll("section.cta-banner");

    if (banners) {
      banners.forEach((banner) => {
        const buttons = banner.querySelector(".cta-banner__links");
        const icons = banner.querySelector(".cta-banner__icons");
        const bgImage = banner.querySelector(".cta-banner__bg-image");
        if (window.innerWidth >= $large) {
          if (buttons) {
            bgImage.style.transform = `translate(calc(-50% - ${
              buttons.offsetWidth * 0.5
            }px - 12px), 0)`;
          } else if (icons) {
            bgImage.style.transform = `translate(calc(-50% - ${
              icons.offsetWidth * 0.5
            }px - 12px), 0)`;
          } else {
            bgImage.style.transform = `translate(calc(-50% - 12px), 0)`;
          }
        } else {
          bgImage.style.transform = `unset`;
        }
      });
    }
  }

  /*Tab Carousel*/
  function tabCarousel() {
    const blocks = document.querySelectorAll("section.tab-carousel");

    blocks.forEach((block) => {
      const carousel = new Flickity(
        block.querySelector(".tab-carousel__container"),
        {
          pageDots: false,
          resize: true,
          autoPlay: true,
          wrapAround: false,
          adaptiveHeight: true,
          prevNextButtons: false,
          draggable: true,
          fade: true,
          initialIndex: 0,
        }
      );

      //Mobile nav
      const navCarousel = new Flickity(
        block.querySelector(".tab-carousel__mobile-nav-ul"),
        {
          pageDots: false,
          resize: true,
          autoPlay: true,
          wrapAround: false,
          adaptiveHeight: false,
          prevNextButtons: false,
          draggable: true,
          cellAlign: "center",
          initialIndex: 0,
        }
      );

      //Handle nav clicks
      block
        .querySelectorAll(".tab-carousel__nav-a, .tab-carousel__mobile-nav-a")
        .forEach((a) => {
          a.addEventListener("click", (e) => {
            e.preventDefault();
            const index = [...a.parentNode.parentNode.children].indexOf(
              a.parentNode
            );
            navCarousel.select(index);
          });
        });

      //Handle mobile nav drag
      navCarousel.on("change", () => {
        carousel.select(navCarousel.selectedIndex);
      });

      //Highlight currently active nav item
      function highlightActiveNav() {
        block
          .querySelectorAll(".tab-carousel__nav-a, .tab-carousel__mobile-nav-a")
          .forEach((a) => {
            const index = [...a.parentNode.parentNode.children].indexOf(
              a.parentNode
            );

            a.classList.remove("tab-carousel__nav-a--is-selected");
            a.classList.remove("tab-carousel__mobile-nav-a--is-selected");

            if (
              a.classList.contains("tab-carousel__nav-a") &&
              index == carousel.selectedIndex
            ) {
              a.classList.add("tab-carousel__nav-a--is-selected");
            } else if (
              a.classList.contains("tab-carousel__mobile-nav-a") &&
              index == carousel.selectedIndex
            ) {
              a.classList.add("tab-carousel__mobile-nav-a--is-selected");
            }
          });

        block.querySelectorAll(".tab-carousel__dot").forEach((dot) => {
          const index = [...dot.parentNode.children].indexOf(dot);

          dot.classList.remove("tab-carousel__dot--is-selected");
          if (index == carousel.selectedIndex) {
            dot.classList.add("tab-carousel__dot--is-selected");
          }
        });
      }

      carousel.on("change", highlightActiveNav);
    });
  }

  /*Resource Panels*/
  function resourcePanels() {
    const blocks = document.querySelectorAll("section.resource-panels");

    blocks.forEach((block) => {
      const filters = block.querySelectorAll(".resource-panels__filter-a");
      const mobileFilters = block.querySelectorAll(
        ".resource-panels__mobile-filter-a"
      );
      let panels = block.querySelectorAll(".resource-panels__panel");
      const loadContainer = block.querySelector(".resource-panels__load");
      const loadButton = block.querySelector(".resource-panels__load-button");
      const loadIcon = block.querySelector(".resource-panels__load-icon");

      filters.forEach((filter) => {
        filter.addEventListener("click", (e) => {
          e.preventDefault();

          filters.forEach((el) =>
            el.classList.remove("resource-panels__filter-a--active")
          );
          e.target.classList.add("resource-panels__filter-a--active");
          showType(filter.parentNode.dataset.type);
        });
      });

      function showType(type) {
        panels.forEach((panel) => {
          if (type == "all") {
            panel.classList.add("resource-panels__panel--active");
          } else {
            if (!panel.classList.contains(`resource-panels__panel--${type}`)) {
              panel.classList.remove("resource-panels__panel--active");
            } else {
              panel.classList.add("resource-panels__panel--active");
            }
          }
        });
      }

      loadButton.addEventListener("click", (e) => {
        e.preventDefault();
        loadMore();
      });

      function loadMore() {
        loadButton.classList.add("resource-panels__load-button--hidden");
        loadButton.setAttribute("disabled", "true");
        loadIcon.classList.add("resource-panels__load-icon--active");

        const offset = block.querySelectorAll(".resource-panels__panel").length;

        fetch("/wp-json/iwrap/v1/loadResourcePanels", {
          method: "POST",
          body: JSON.stringify({
            offset: offset,
            number: 6,
          }),
          headers: new Headers({
            "Content-Type": "application/json; charset=UTF-8",
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            json.data.forEach((item) => {
              const newDiv = document.createElement("div");
              newDiv.className = `resource-panels__panel resource-panels__panel--loaded resource-panels__panel--active resource-panels__panel--${item.type
                .replace(/(^\-+|[^a-zA-Z0-9\/_| -]+|\-+$)/g, "")
                .toLowerCase()
                .replace(/[\/_| -]+/g, "-")}`;

              newDiv.innerHTML = ` <div class="resource-panels__panel-image" style="background-image: url('${
                item.image
              }');"></div>
              <div class="resource-panels__panel-type">${item.type}</div>
              <div class="resource-panels__panel-content">
                <h5 class="resource-panels__panel-heading">${item.title}</h5>
                <p class="resource-panels__panel-text">${item.text}</p>
                <a href="${
                  item.link.url
                }" class="iwrap-button resource-panels__panel-link">${
                item.type == "Video" ? "Watch now" : "Read more"
              }</a>
              </div>`;

              block
                .querySelector(".resource-panels__load")
                .insertAdjacentElement("beforeBegin", newDiv);
            });

            const cont = block.querySelector(".resource-panels__container");

            if (cont.dataset.animate == "1") {
              anime({
                targets: block.querySelectorAll(
                  ".resource-panels__panel--loaded"
                ),
                opacity: [0, 1],
                translateY: [50, 0],
                easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
                delay: anime.stagger(cont.dataset.delay),
              });
            }

            if (json.moreToLoad) {
              loadButton.classList.remove(
                "resource-panels__load-button--hidden"
              );
              loadButton.removeAttribute("disabled");
              loadIcon.classList.remove("resource-panels__load-icon--active");
            } else {
              loadContainer.remove();
            }

            panels = block.querySelectorAll(".resource-panels__panel");
          })
          .catch((err) => {
            console.log(err);
          });
      }

      //Mobile filters
      const carousel = new Flickity(
        block.querySelector(".resource-panels__mobile-filter-ul"),
        {
          pageDots: false,
          resize: true,
          autoPlay: false,
          wrapAround: true,
          adaptiveHeight: false,
          prevNextButtons: true,
          draggable: true,
          initialIndex: 0,
          cellAlign: "center",
        }
      );

      mobileFilters.forEach((filter) => {
        filter.addEventListener("click", (e) => {
          e.preventDefault();
          carousel.select(Number(e.target.parentNode.dataset.index));
        });
      });

      carousel.on("change", () => {
        showType(carousel.selectedElement.dataset.type);
      });
    });
  }

  /*Site Header Nav Control*/
  class SiteHeaderNav {
    constructor() {
      this.siteHeader = document.querySelector("header.site-header");
      this.megaMenu = document.querySelector(".mega-menu");
      this.mobileMenu = document.querySelector(".mobile-menu");

      this.navLinks = this.siteHeader.querySelectorAll(
        ".site-header__nav-link"
      );
      this.mobileNavLinks = this.mobileMenu.querySelectorAll(
        ".site-header__mobile-nav-link"
      );

      this.subNavs = this.megaMenu.querySelectorAll(".site-header__subnav");
      this.subNavLinks = this.megaMenu.querySelectorAll(
        ".site-header__subnav-link"
      );
      this.mobileSubNavs = this.mobileMenu.querySelectorAll(
        ".site-header__mobile-subnav"
      );
      this.mobileSubNavBack = this.mobileMenu.querySelectorAll(
        ".site-header__mobile-subnav-back"
      );
      this.mobileSubNavLinks = this.mobileMenu.querySelectorAll(
        ".site-header__mobile-subnav-link"
      );
      this.openMenuButton = this.siteHeader.querySelector(
        ".site-header__menu-button--open"
      );
      this.closeMenuButton = this.siteHeader.querySelector(
        ".site-header__menu-button--close"
      );

      this.mobileBg = this.mobileMenu.querySelector(".site-header__mobile-bg");
      if (this.siteHeader.dataset.active) {
        this.events();
      }
    }

    events() {
      // this.siteHeader.addEventListener("mouseleave", (e) =>
      //   this.closeMegaMenu(e)
      // );
      // this.megaMenu.addEventListener("mouseleave", e => this.closeMegaMenu(e))
      this.navLinks.forEach((link) => {
        link.addEventListener("click", (e) => this.menuControl(e, link));
      });
      this.subNavLinks.forEach((link) => {
        link.addEventListener("click", (e) => this.openSubNav(e, link));
      });
      this.mobileNavLinks.forEach((link) => {
        link.addEventListener("click", (e) =>
          this.activateMobileSubNav(e, link)
        );
      });
      this.mobileSubNavLinks.forEach((link) => {
        link.addEventListener("click", (e) =>
          this.activateMobileSubNav(e, link)
        );
      });
      this.openMenuButton.addEventListener("click", (e) =>
        this.openMobileMenu(e)
      );
      this.closeMenuButton.addEventListener("click", (e) =>
        this.closeMobileMenu(e)
      );
      this.mobileSubNavBack.forEach((back) => {
        back.addEventListener("click", (e) => {
          this.mobileSubNavReturn(e, back);
        });
      });
    }

    menuControl(e, link) {
      if (link.classList.contains("site-header__nav-link--active")) {
        this.closeMegaMenu(e);
      } else {
        this.openMegaMenu(e, link);
      }
    }

    openMegaMenu(e, link) {
      if (link.dataset.children == "true") {
        e.preventDefault();

        if (
          !this.megaMenu.classList.contains("site-header__mega-menu--active") ||
          this.currentlyOpen != link.dataset.id
        ) {
          this.currentlyOpen = link.dataset.id;

          this.navLinks.forEach((link) =>
            link.classList.remove("site-header__nav-link--active")
          );
          link.classList.add("site-header__nav-link--active");

          this.megaMenu.classList.add("site-header__mega-menu--active");

          this.subNavs.forEach((subNav) => {
            subNav.classList.remove("site-header__subnav--active");

            if (link.dataset.id == subNav.dataset.parent) {
              subNav.classList.add("site-header__subnav--active");
            }
          });
        } else {
          this.closeMegaMenu();
        }
      } else {
        this.closeMegaMenu();
      }
    }

    closeMegaMenu(e) {
      e.preventDefault();
      this.megaMenu.classList.remove("site-header__mega-menu--active");

      this.navLinks.forEach((link) =>
        link.classList.remove("site-header__nav-link--active")
      );

      setTimeout(() => {
        this.subNavs.forEach((subNav) => {
          subNav.classList.remove("site-header__subnav--active");
        });
      }, 350);
    }

    openSubNav(e, link) {
      if (link.dataset.children == "true") {
        e.preventDefault();

        this.subNavs.forEach((subNav) => {
          if (
            link.closest(".site-header__subnav").dataset.depth <
            subNav.dataset.depth
          ) {
            subNav.classList.remove(
              "site-header__subnav--active",
              "site-header__subnav--visible"
            );
          }
          if (link.dataset.id == subNav.dataset.parent) {
            subNav.classList.add("site-header__subnav--active");
            setTimeout(() => {
              subNav.classList.add("site-header__subnav--visible");
            }, 10);
          }
        });
      }
    }

    openMobileMenu(e) {
      if (
        !this.mobileMenu.classList.contains("site-header__mobile-nav--active")
      ) {
        this.mobileMenu.classList.add("site-header__mobile-nav--active");
        this.closeMenuButton.classList.remove(
          "site-header__menu-button--hidden"
        );
        this.openMenuButton.classList.add("site-header__menu-button--hidden");
      }
    }

    closeMobileMenu(e) {
      if (
        this.mobileMenu.classList.contains("site-header__mobile-nav--active")
      ) {
        this.mobileMenu.classList.remove("site-header__mobile-nav--active");
        this.closeMenuButton.classList.add("site-header__menu-button--hidden");
        this.openMenuButton.classList.remove(
          "site-header__menu-button--hidden"
        );
        this.mobileSubNavs.forEach((subNav) => {
          subNav.classList.remove(
            "site-header__mobile-subnav--active",
            "site-header__mobile-subnav--hidden"
          );
        });
        this.mobileBg.classList.remove("site-header__mobile-bg--active");
      }
    }

    activateMobileSubNav(e, link) {
      if (link.dataset.children == "true") {
        e.preventDefault();

        const closestNav = link.closest(".site-header__mobile-subnav");

        if (!closestNav) {
          this.mobileBg.classList.add("site-header__mobile-bg--active");
        }

        this.mobileSubNavs.forEach((subNav) => {
          if (closestNav) {
            if (subNav.dataset.depth == closestNav.dataset.depth - 1) {
              subNav.classList.add("site-header__mobile-subnav--hidden");
            }
          }

          if (link.dataset.id == subNav.dataset.parent) {
            subNav.classList.add("site-header__mobile-subnav--active");
          }
        });

        if (closestNav) {
          closestNav.classList.add("site-header__mobile-subnav--hidden");
        }
      }
    }

    mobileSubNavReturn(e, link) {
      const closestNav = link.closest(".site-header__mobile-subnav");

      closestNav.classList.remove("site-header__mobile-subnav--active");

      this.mobileSubNavs.forEach((subNav) => {
        if (closestNav.dataset.depth == 1) {
          this.mobileBg.classList.remove("site-header__mobile-bg--active");
        }

        if (subNav.dataset.depth == closestNav.dataset.depth - 1) {
          subNav.classList.remove("site-header__mobile-subnav--hidden");
        }
      });
    }
  }

  /*Product Panels*/
  function productPanels() {
    const blocks = document.querySelectorAll("section.product-panels");

    blocks.forEach((block) => {
      const carouselClass = block.querySelector(
        ".product-panels__container--carousel"
      );

      function setBg() {
        const panel = block.querySelector(".product-panels__panel");
        const panelBg = block.querySelector(".product-panels__panel-image");
        const panelTop = panel.offsetTop;
        let bgBottom = panelTop + panelBg.offsetHeight;

        if (carouselClass) {
          bgBottom += carouselClass.offsetTop;
        }

        block.setAttribute("style", `--bgOffset: ${bgBottom}px`);
      }

      setBg();

      //Make carousel
      if (carouselClass) {
        const carousel = new Flickity(carouselClass, {
          pageDots: false,
          resize: true,
          autoPlay: carouselClass.dataset.autoplay ? 5000 : false,
          wrapAround: false,
          adaptiveHeight: false,
          prevNextButtons: true,
          draggable: true,
          initialIndex: 0,
          cellAlign: "left",
          contain: true,
          pageDots: true,
          groupCells: true,
          on: {
            ready: function () {
              setBg();
            },
          },
        });
      }
    });
  }

  /*Product Panels BG*/
  function productPanelsBg() {
    const blocks = document.querySelectorAll("section.product-panels");

    blocks.forEach((block) => {
      const carouselClass = block.querySelector(
        ".product-panels__container--carousel"
      );

      const panel = block.querySelector(".product-panels__panel");
      const panelBg = block.querySelector(".product-panels__panel-image");
      const panelTop = panel.offsetTop;
      let bgBottom = panelTop + panelBg.offsetHeight;

      if (carouselClass) {
        bgBottom += carouselClass.offsetTop;
      }

      block.setAttribute("style", `--bgOffset: ${bgBottom}px`);
    });
  }

  /*Product Carousel*/
  function productCarousel() {
    const blocks = document.querySelectorAll("section.product-carousel");

    blocks.forEach((block) => {
      const carousel = new Flickity(
        block.querySelector(".product-carousel__container"),
        {
          pageDots: false,
          resize: true,
          autoPlay: false,
          wrapAround: false,
          adaptiveHeight: false,
          prevNextButtons: false,
          draggable: true,
          initialIndex: 0,
          cellAlign: "center",
        }
      );

      //Nav
      const navCarousel = new Flickity(
        block.querySelector(".product-carousel__nav-ul"),
        {
          pageDots: false,
          resize: true,
          autoPlay: false,
          wrapAround: false,
          adaptiveHeight: false,
          prevNextButtons: false,
          draggable: false,
          initialIndex: 0,
          cellAlign: "center",
          contain: true,
        }
      );

      //Handle nav clicks
      block.querySelectorAll(".product-carousel__nav-a").forEach((a) => {
        a.addEventListener("click", (e) => {
          e.preventDefault();
          const index = [...a.parentNode.parentNode.children].indexOf(
            a.parentNode
          );
          navCarousel.select(index);
        });
      });

      block
        .querySelector(".product-carousel__nav-button--previous")
        .addEventListener("click", () => {
          navCarousel.previous(true);
        });

      block
        .querySelector(".product-carousel__nav-button--next")
        .addEventListener("click", () => {
          navCarousel.next(true);
        });

      navCarousel.on("change", () => {
        carousel.select(navCarousel.selectedIndex);
      });

      //Update nav on change
      carousel.on("change", () => {
        navCarousel.select(carousel.selectedIndex);
      });

      //Add padding to previous block if overlapping
      const prev = block.previousElementSibling;
      const prevPadding =
        getComputedStyle(prev).getPropertyValue("padding-bottom");
      prev.style.paddingBottom = `calc(${prevPadding} + 50px)`;
    });
  }

  /*Testimonials Carousel*/
  function testCarousel() {
    const blocks = document.querySelectorAll("section.testimonial-carousel");

    blocks.forEach((block) => {
      const carousel = new Flickity(
        block.querySelector(".testimonial-carousel__container"),
        {
          resize: true,
          wrapAround: true,
          adaptiveHeight: false,
          prevNextButtons: false,
          draggable: true,
          initialIndex: 0,
          cellAlign: "center",
          pageDots: true,
          autoPlay: parseInt(block.dataset.autoplay * 1000),
        }
      );
    });
  }

  /*Event Calendar*/
  function eventCalendar() {
    const blocks = document.querySelectorAll("section.event-calendar");

    blocks.forEach((block) => {
      const carousel = new Flickity(
        block.querySelector(".event-calendar__container"),
        {
          resize: true,
          wrapAround: false,
          contain: true,
          adaptiveHeight: false,
          prevNextButtons: false,
          draggable: true,
          initialIndex: 0,
          cellAlign: "center",
          pageDots: true,
          autoPlay: block.dataset.autoplay
            ? parseInt(block.dataset.autoplay * 1000)
            : false,
        }
      );

      const singleCarousel = new Flickity(
        block.querySelector(".event-calendar__container-single"),
        {
          resize: true,
          wrapAround: false,
          contain: true,
          adaptiveHeight: false,
          prevNextButtons: false,
          draggable: true,
          initialIndex: 0,
          cellAlign: "center",
          pageDots: true,
          autoPlay: block.dataset.autoplay
            ? parseInt(block.dataset.autoplay * 1000)
            : false,
        }
      );
    });
  }

  /*Accordion*/
  function accordionInit() {
    const accordions = document.querySelectorAll(".faq-accordion");

    accordions.forEach((acc) => {
      //Load more functionality
      const loadButton = acc.querySelector(".faq-accordion__load");

      if (loadButton) {
        loadButton.addEventListener("click", (e) => {
          loadPosts(e);
        });
      }

      function loadPosts(e) {
        e.preventDefault();

        //Async post loading
        const accItems = acc.querySelector(".accordion");
        const currentPosts = acc.querySelectorAll(".accordion-item").length;
        const postId = acc.dataset.id;
        const color = acc.dataset.color;
        const border = acc.dataset.border;
        const loadNumber = acc.dataset.load;
        const loading = acc.querySelector(".faq-accordion__loading");

        loading.classList.add("faq-accordion__loading--active");
        loadButton.classList.add("faq-accordion__load--hidden");

        fetch("/wp-json/iwrap/v1/loadFaqPosts", {
          method: "POST",
          body: JSON.stringify({
            offset: currentPosts,
            id: postId,
            load: loadNumber,
          }),
          headers: new Headers({
            "Content-Type": "application/json; charset=UTF-8",
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            json.data.forEach((item, index) => {
              const newDiv = document.createElement("div");
              newDiv.className = `accordion-item accordion-item--loaded accordion-item--${color} accordion-item--border-${border}`;

              newDiv.innerHTML = `<h2 class="accordion-header" id="heading${
                index + 1 + currentPosts
              }">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse${
              index + 1 + currentPosts
            }" aria-expanded="false" aria-controls="collapse${
                index + 1 + currentPosts
              }">
              ${item.question}
            </button>  
          </h2>
          <div id="collapse${
            index + 1 + currentPosts
          }" class="accordion-collapse collapse" aria-labelledby="heading${
                index + 1 + currentPosts
              }">
            <div class="accordion-body">
              ${item.answer}
            </div>
          </div>`;

              acc
                .querySelector(".faq-accordion__body")
                .insertAdjacentElement("beforeEnd", newDiv);
            });

            const cont = acc.querySelector(".faq-accordion__container");

            if (cont.dataset.animate == "1") {
              anime({
                targets: acc.querySelectorAll(".accordion-item--loaded"),
                scaleX: [0, 1],
                easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
                delay: anime.stagger(cont.dataset.delay),
                changeBegin: function (anim) {
                  anim.animatables.forEach((ani) => {
                    ani.target.classList.remove("accordion-item--loaded");
                  });
                },
              });
            }

            loading.classList.remove("faq-accordion__loading--active");

            if (json.moreToLoad) {
              loadButton.classList.remove("faq-accordion__load--hidden");
            } else {
              acc.querySelector(".faq-accordion__load-wrapper").remove();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  /*Stats & Numbers*/
  function statsNumbers() {
    const numbers = document.querySelectorAll(".stats-numbers__num");

    anime({
      targets: numbers,
      innerText: [0, 100],
      easing: "linear",
      duration: 2000,
      round: true,
      delay: anime.stagger(500),
      update: function (a) {
        const value = a.animations[0].currentValue;
        a.animations[0].innerHTML = value;
      },
    });
  }

  /*Debounce function*/
  function debounce(func, timeout = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  /*Animation*/
  /*Reusable class to calculate when target elements have scrolled to a certain point on the screen, at which point the animation function is called. Pass in an array of elements to animate, a number from 0 - 100 representing the percentage of the viewport height at which to trigger the animation, and the animation function itself.*/
  class Animate {
    constructor(els, thresholdPercent, animationFunction) {
      this.targets = els;
      this.thresholdPercent = thresholdPercent;
      this.animationFunction = animationFunction;
      this.browserHeight = window.innerHeight;
      this.setInitial();
      this.scrollThrottle = lodash.throttle(this.calcCaller, 200).bind(this);
      this.events();
      this.calcCaller();
    }

    events() {
      window.addEventListener("scroll", this.scrollThrottle);
      window.addEventListener(
        "resize",
        debounce(() => {
          this.browserHeight = window.innerHeight;
        }, 200)
      );
    }

    calcCaller() {
      this.targets.forEach((el, index) => {
        if (el.activated == false && el.dataset.animate == "1") {
          this.calculateIfScrolledTo(el, index);
        }
      });
    }

    setInitial() {
      this.targets.forEach((el) => {
        el.classList.add("animate-item");
        el.activated = false;
      });
      if (this.targets.length) {
        this.targets[this.targets.length - 1].isLastItem = true;
      }
    }

    calculateIfScrolledTo(el, index) {
      if (window.scrollY + this.browserHeight > el.offsetTop) {
        let scrollPercent =
          (el.getBoundingClientRect().y / this.browserHeight) * 100;
        if (scrollPercent < this.thresholdPercent) {
          el.classList.add("animate-item--activated");
          el.activated = true;

          this.animationFunction(el, index);

          if (el.isLastItem) {
            window.removeEventListener("scroll", this.scrollThrottle);
          }
        }
      }
    }
  }

  /*ANIMATION FUNCTIONS*/

  /*Stats & Numbers*/
  function statsNumbersAnim(el, index) {
    const start = Number(el.dataset.start);
    const end = Number(el.dataset.end);
    const duration = Number(el.dataset.duration);
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el,
      innerText: [start, end],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      duration: duration,
      round: true,
      delay: delay,
    });
  }

  /*Product Panels*/
  function productPanelsAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el,
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
      complete: function (anim) {
        productPanelsBg();
      },
    });
  }

  /*Single Text Column*/
  function singleTextColumnAnim(el, index) {
    anime({
      targets: el.querySelectorAll(":scope > *"),
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });
  }

  /*Selling Points*/
  function sellingPointsAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el.querySelectorAll(".selling-points__text"),
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });

    anime({
      targets: el.querySelectorAll(".selling-points__image"),
      scale: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });
  }

  /*Image & Text*/
  function imageTextAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el.querySelectorAll(".image-and-text__content"),
      opacity: [0, 1],
      translateX: [-50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });

    anime({
      targets: el.querySelectorAll(".image-and-text__image"),
      opacity: [0, 0, 0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });
  }

  /*CTA Banner*/
  function ctaBannerAnim(el, index) {
    const delay = Number(index * el.dataset.delay);
    const width = window.innerWidth;

    anime({
      targets: el.querySelectorAll(".cta-banner__heading, .cta-banner__text"),
      opacity: [0, 1],
      translateX: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });

    anime({
      targets: el.querySelectorAll(".cta-banner__link"),
      scale: 1,
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      // delay: delay,
    });

    if (width >= 992) {
      anime({
        targets: el.querySelectorAll(".cta-banner__bg-image > img"),
        opacity: [0, 1],
        rotate: ["-135deg", "0deg"],
        easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
        duration: 1000,
        delay: delay,
      });
    } else {
      anime({
        targets: el.querySelectorAll(".cta-banner__bg-image > img"),
        opacity: [0, 0.25],
        rotate: ["-135deg", "0deg"],
        translateX: ["-50%", "-50%"],
        translateY: ["-50%", "-50%"],
        easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
        duration: 1000,
        delay: delay,
      });
    }
  }

  /*Hero Banner*/
  function heroBannerAnim(el, index) {
    anime({
      targets: el.querySelectorAll(".hero-banner__content"),
      opacity: [0, 1],
      translateX: [-50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
    });

    anime({
      targets: el.querySelectorAll(".hero-banner__image-wrapper"),
      opacity: [0, 1],
      translateX: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
    });
  }

  /*Resource Panels*/
  function resourcePanelsAnim(el, index) {
    anime({
      targets: el.querySelectorAll(".resource-panels__panel"),
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });
  }

  /*Tab Carousel*/
  function tabCarouselAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el.querySelectorAll(".tab-carousel__slide > *:nth-child(1)"),
      opacity: [0, 1],
      translateX: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });

    anime({
      targets: el.querySelectorAll(".tab-carousel__slide > *:nth-child(2)"),
      opacity: [0, 1],
      translateX: [-50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });
  }

  /*Testimonial Carousel*/
  function testimonialCarouselAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el.querySelectorAll(
        ".testimonial-carousel__content, .testimonial-carousel__info"
      ),
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });
  }

  /*Event Calendar*/
  function eventCalendarAnim(el, index) {
    anime({
      targets: el,
      opacity: [0, 1],
      translateX: function () {
        if (index % 2 == 0) {
          return [-50, 0];
        } else {
          return [50, 0];
        }
      },
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });
  }

  /*Team Profiles*/
  function teamProfilesAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el,
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });
  }

  /*List On Gradient*/
  function listOnGradientAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el.querySelectorAll(".list-on-gradient__item"),
      opacity: [0, 1],
      scale: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });

    anime({
      targets: el.querySelectorAll(".list-on-gradient__text-column > *"),
      opacity: [0, 1],
      translateY: [50, 0],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });
  }

  /*FAQ Accordion*/
  function faqAccordionAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el.querySelectorAll(".accordion-item"),
      scaleX: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });
  }

  /*Product Carousel*/
  function productCarouselAnim(el, index) {
    const delay = Number(index * el.dataset.delay);

    anime({
      targets: el,
      translateY: [50, 0],
      opacity: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: delay,
    });
  }

  /*Form*/
  function formAnim(el, index) {
    anime({
      targets: el.querySelectorAll(
        ".overlapping-cta-form__form > *, .wpcf7-form-control-wrap"
      ),
      translateY: [50, 0],
      opacity: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
      delay: anime.stagger(el.dataset.delay),
    });

    anime({
      targets: el.querySelectorAll(".overlapping-cta-form__bg-image"),
      opacity: [0, 1],
      duration: 500,
      delay: 1000,
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
    });
  }

  /*Client Logos*/
  function clientLogosAnim(el, index) {
    anime({
      targets: el.querySelectorAll(".client-logos__item"),
      opacity: [0, 1],
      duration: el.dataset.duration,
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
    });
  }

  /*CTA Image Banner*/
  function ctaImageBannerAnim(el, index) {
    anime({
      targets: el.querySelectorAll(".cta-image-banner__image"),
      translateX: [50, 0],
      opacity: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
    });

    anime({
      targets: el.querySelectorAll(".cta-image-banner__content"),
      translateX: [-50, 0],
      opacity: [0, 1],
      easing: "cubicBezier(0.5, 0.000, 0.5, 1.000)",
    });
  }

  function sortResourceScroll() {
    //console.log(window.location.pathname.split("/").filter(a => a.length > 0).length);
    //console.log(window.location.pathname.indexOf('resources'));
    if (window.location.pathname.indexOf('resources') === 1 && window.location.pathname.split("/").filter(a => a.length > 0).length === 2) {
      // if it's the resources archive page and there's only one additional segment - means we're on resources archive page with a category selected, so autoscroll to the results
      console.log('true');
      window.scrollTo(0, document.getElementById('resource-nav').offsetTop - document.getElementsByClassName('site-header')[0].offsetHeight);
    }
  }

  function makeMenuHide() {
    $('.site-header__subnav-link:not(.site-header__subnav-link--has-children)').on('click',function(){
      $('.site-header__mega-menu').removeClass('site-header__mega-menu--active');
      $('.site-header__nav-link').removeClass('site-header__nav-link--active');
    });
  }

  /***
  ********
  ****
  Functions which require document to be ready
  ****
  ********
  ***/
  $(function () {
    pellingNavbar();
    returnTop();
    gdprConsent();
    animateSections();
    animatedStatistics();
    clientCarousel();
    bsTabs();
    isotopeGallery();
    horizontalTabsInit();
    testimonialCarouselInit();
    carouselInit();
    resourcesCarouselInit();
    heroCarousel();
    portfolioCarousel();
    // dynamicBannerHeight();
    bannerDynamicCSS(".inset-banner");
    bannerDynamicCSS(".cta-image-banner");
    heroCarouselInit();
    clientsCarousel();
    ctaBanner();
    tabCarousel();
    resourcePanels();
    const siteHeader = new SiteHeaderNav();
    productPanels();
    productCarousel();
    testCarousel();
    eventCalendar();
    accordionInit();
    productPanelsBg();
    sortResourceScroll();
    makeMenuHide();

    document.querySelectorAll(".overlap-next").forEach((el) => {
      overlapNext(el);
    });

    const thresholdPercent = 90;

    //Animated stats/numbers counter
    new Animate(
      document.querySelectorAll(".stats-numbers__num"),
      thresholdPercent,
      statsNumbersAnim
    );

    //Animated product panels
    new Animate(
      document.querySelectorAll(".product-panels__panel"),
      thresholdPercent,
      productPanelsAnim
    );

    //Animated STC
    new Animate(
      document.querySelectorAll(".single-text-column__container"),
      thresholdPercent,
      singleTextColumnAnim
    );

    //Animated selling points
    new Animate(
      document.querySelectorAll(".selling-points__column"),
      thresholdPercent,
      sellingPointsAnim
    );

    //Animated image/text
    new Animate(
      document.querySelectorAll(".image-and-text__container"),
      67,
      imageTextAnim
    );

    //Animated CTA banner
    new Animate(
      document.querySelectorAll(".cta-banner"),
      thresholdPercent,
      ctaBannerAnim
    );

    //Animated hero banner
    new Animate(
      document.querySelectorAll(".hero-banner"),
      thresholdPercent,
      heroBannerAnim
    );

    //Animated resource panels
    new Animate(
      document.querySelectorAll(".resource-panels__container"),
      thresholdPercent,
      resourcePanelsAnim
    );

    //Animated tab carousel
    new Animate(
      document.querySelectorAll(".tab-carousel__container"),
      thresholdPercent,
      tabCarouselAnim
    );

    //Animated testimonial carousel
    new Animate(
      document.querySelectorAll(".testimonial-carousel__test"),
      thresholdPercent,
      testimonialCarouselAnim
    );

    //Animated event calendar
    new Animate(
      document.querySelectorAll(".event-calendar__event"),
      thresholdPercent,
      eventCalendarAnim
    );

    //Animated team profiles
    new Animate(
      document.querySelectorAll(".team-profiles__member"),
      thresholdPercent,
      teamProfilesAnim
    );

    //Animated LOG
    new Animate(
      document.querySelectorAll(".list-on-gradient"),
      thresholdPercent,
      listOnGradientAnim
    );

    //Animated FAQA
    new Animate(
      document.querySelectorAll(".faq-accordion__container"),
      thresholdPercent,
      faqAccordionAnim
    );

    //Animated product carousel
    new Animate(
      document.querySelectorAll(".product-carousel__product-grid"),
      thresholdPercent,
      productCarouselAnim
    );

    //Animated form
    new Animate(
      document.querySelectorAll(".overlapping-cta-form"),
      thresholdPercent,
      formAnim
    );

    //Animated client logos
    new Animate(
      document.querySelectorAll(".client-logos"),
      thresholdPercent,
      clientLogosAnim
    );

    //Animated cta image banner
    new Animate(
      document.querySelectorAll(".cta-image-banner"),
      thresholdPercent,
      ctaImageBannerAnim
    );

    windowObj.on(
      "resize",
      debounce(function () {
        bannerDynamicCSS(".cta-image-banner");
        bannerDynamicCSS(".inset-banner");
        heroCarouselInit();
        clientsCarousel();
        portfolioCarousel();
        ctaBanner();
        productPanels();

        document.querySelectorAll(".overlap-next").forEach((el) => {
          overlapNext(el);
        });
      })
    );
  });
})(jQuery); // Fully reference jQuery after this point.
